export default "__VITE_ASSET__CU9hCX4E__"